export default __webpack_public_path__ + "static/media/bx-right-arrow.678eb67a.svg";